import React, { Component, Fragment} from 'react';

import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import './Login.Module.scss';

import Top from 'components/UI/Top/Top';
import FilterMenu from 'components/UI/FilterMenu/FilterMenu';

/**
 * import components
 */

import loginUser from 'actions/authentication/login';

const mapDispatchToProps = {
    loginUser
};

const mapStateToProps = (state, props) => {
    return {
        authentication: state.authentication,
        user: state.authentication.user
    };
};

class Login extends Component {

    constructor() {
        super();

        this.state = {
            email: '',
            password: ''
        }

        this.handleFieldChange  = this.handleFieldChange.bind(this);
        this.handleLogin        = this.handleLogin.bind(this);
    }

    handleFieldChange(event) {
        if(event.target.name == 'email') {
            
            this.setState({email: event.target.value});

        } else if(event.target.name == 'password') {

            this.setState({password: event.target.value});
        }
    }

    handleLogin() {
        this.props.loginUser(this.state).then(result => {
            ReactGA.event({
                category: "Sign in",
                action: "User logged in",
            });
            ReactGA.set({
                userId: this.props.user.id
            });
        });
    }

    render() {

        return (
            <Fragment>
                
                <Top></Top>
                <div styleName='pagewrapper'>
                    <FilterMenu display="false"></FilterMenu>
                    <div styleName='wrapper'>
                        <h1>INLOGGEN</h1>
                        <h3 style={{fontStyle: 'italic'}}>Log in en stel je eigen leerlijn samen.</h3>
                        
                        <form styleName='form'>
                            <input styleName='input' value={this.state.email} onChange={this.handleFieldChange} name='email' type="text" placeholder="email" />
                            <input styleName='input' value={this.state.password} onChange={this.handleFieldChange} name='password' type="password" placeholder="Wachtwoord" />
                            <div styleName='button-wrapper'>
                                <div onClick={()=> {this.props.history.push('/registreren')}} styleName="submit" >Registreren</div>
                                <a href="#" onClick={this.handleLogin} styleName="submit" >Login</a>
                            </div>
                        </form>
                        <div styleName='forgot-password2' style={{cursor:'pointer'}} onClick={()=>{this.props.history.push('/wachtwoord-vergeten')}}>Wachtwoord vergeten?<br></br> Klik hier om opnieuw in te stellen</div>
                        
                        
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
